/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_UpdateInvoiceStatusRequest = {
    /**
     * CancellationReason is required when status is "cancelled" (backend validation enforced). Must be between 10 and 500 characters.
     */
    cancellation_reason?: string;
    /**
     * Status to update to (only certain transitions allowed)
     */
    status: billing_UpdateInvoiceStatusRequest.status;
};
export namespace billing_UpdateInvoiceStatusRequest {
    /**
     * Status to update to (only certain transitions allowed)
     */
    export enum status {
        DRAFT = 'draft',
        FINALIZED = 'finalized',
        SENT = 'sent',
        PAID = 'paid',
        PARTIAL = 'partial',
        OVERDUE = 'overdue',
        CANCELLED = 'cancelled',
        CREDITED = 'credited',
    }
}

